
import { computed, defineComponent, ref, watch, toRef, onMounted,PropType,nextTick,onUnmounted, onBeforeUnmount } from 'vue';
import Sketch from '../sketch/sketch.vue';
import { GradientColor, ColorType } from '@qcolor/utils/gradientTools/gradientModel';
import { gradientString, gradientPointColors } from '@qcolor/utils/gradientTools/gradientTools';

import html2canvas from 'html2canvas';
import { cloneDeep, debounce, uniq, some } from 'lodash-es';
import { ElProgress } from 'element-plus';
import { ElMessage } from 'element-plus';
export default defineComponent({
  name: 'ColorSketch',
  components: {
    Sketch,
    ElProgress
  },
  props: {
    color: {
      type: [String, Object],
      default: '#ffffff'
    },
    typeList: {
      type: Array,
      default: () => [ColorType.Color, ColorType.GradientColor]
    },
    selectType: {
      type: Number,
      default: ColorType.Color //gradientColor  color ,ColorType.Image
    },
    uploadInfo: {
      type: Object,
      default: () => ({
        url: '',
        limitSize: 10,
        accept: 'image/png, image/jpeg'
      })
    },
    // recentColorList:{
    //   type:Array,
    //   default:()=>([])
    // },
    // recentGradientList:{
    //   type:Array,
    //   default:()=>([])
    // },
    sketchShow: {
      type: Boolean,
      default: false
    },
    colorMode: {
      type: String,
      default: 'HEX' //'HEX8' 'RGBA' 'HEX' 'RGB'
    },
    hiddenAlpha: {
      type: Boolean,
      default: true
    },
    hiddenRecentColor: {
      type: Boolean,
      default: false
    },
    hiddenBrandColor: {
      type: Boolean,
      default: true
    },
    pictureUrl:{
      type: String,
      default: "",       
    },
    brandColors:{ 
      type: Array as PropType<any>,
      default: () => [],      
    }
  },
  setup(props, { attrs, slots, emit, expose }) {
    //#194D33A8
    const imageUrl = ref(props.pictureUrl);
    const isUpload = ref(false);//是否正在上传图片
    const fileName = ref('');
    const progressText = ref(0);
    const colorMap = {
      [ColorType.Color]: '纯色',
      [ColorType.GradientColor]: '渐变',
      [ColorType.Image]: '图片'
    };
    const gradientDom = ref(null);
    const gradientTrackDom = ref(null);
    const rotateAreaDom = ref(null);

    const recentColorList: any = ref([]);
    const recentGradientList: any = ref([]);

    const uploadText = ref('上传图片');
    //const angle = ref(0);
    const showAngleBox = ref(false);
    const currentGradientIndex = ref(0);
    const myColors: any = ref('#ffffff');
    const myGradientColors: any = ref(new GradientColor());
    const activeTab = ref(props.selectType);

    if (activeTab.value === -1) {
      if (typeof props.color === 'string') {
        activeTab.value = ColorType.Color;
      } else if (typeof props.color === 'object') {
        activeTab.value = ColorType.GradientColor;
      }
    }

    if (activeTab.value === ColorType.Color) {
      myColors.value = cloneDeep(props.color);
    } else if (activeTab.value === ColorType.GradientColor) {
      myGradientColors.value = cloneDeep(props.color);
    }
    // const recentColorList = ref([])
    // const recentGradientList = ref([])
    let strawPreviewDom: any = '';
    let strawing = false;
    //type值为 color direction all
    const updateColor = (color: any, type = 'color') => {
      if (activeTab.value === ColorType.Color) {
        // const colorValue =
        //   typeof color === "string"
        //     ? color
        //     : props.colorMode === "HEX8"
        //     ? color.hex8
        //     : `rgba(${color.rgba.r}, ${color.rgba.g}, ${color.rgba.b}, ${color.rgba.a})`;

        let colorValue = color;
        if (typeof color === 'string') {
          colorValue = color;
        } else {
          if (props.colorMode === 'HEX8') {
            colorValue = color.hex8;
          } else if (props.colorMode === 'HEX') {
            colorValue = color.hex;
          } else if (props.colorMode === 'RGBA') {
            colorValue = `rgba(${color.rgba.r}, ${color.rgba.g}, ${color.rgba.b}, ${color.rgba.a})`;
          } else if (props.colorMode === 'RGB') {
            colorValue = `rgba(${color.rgba.r}, ${color.rgba.g}, ${color.rgba.b})`;
          }
        }
        emit('update:color', colorValue);
        myColors.value = colorValue;
      } else if (activeTab.value === ColorType.GradientColor) {
        const cloneColor = cloneDeep(myGradientColors.value);
        if (type === 'color') {
          // const colorValue =
          //   typeof color === "string"
          //     ? color
          //     : props.colorMode === "HEX8"
          //     ? color.hex8
          //     : `rgba(${color.rgba.r}, ${color.rgba.g}, ${color.rgba.b}, ${color.rgba.a})`;
          let colorValue = color;
          if (typeof color === 'string') {
            colorValue = color;
          } else {
            if (props.colorMode === 'HEX8') {
              colorValue = color.hex8;
            } else if (props.colorMode === 'HEX') {
              colorValue = color.hex;
            } else if (props.colorMode === 'RGBA') {
              colorValue = `rgba(${color.rgba.r}, ${color.rgba.g}, ${color.rgba.b}, ${color.rgba.a})`;
            } else if (props.colorMode === 'RGB') {
              colorValue = `rgba(${color.rgba.r}, ${color.rgba.g}, ${color.rgba.b})`;
            }
          }

          cloneColor.gradient[currentGradientIndex.value].color = colorValue;

          emit('update:color', cloneColor);
        } else if (type === 'all') {
          emit('update:color', color);
        } else if (type === 'direction') {
          cloneColor.direction = color + 'deg';
          emit('update:color', cloneColor);
          console.log('cloneColor',cloneColor);
        }
        myGradientColors.value = cloneColor;
      }

      emit('colorChange');
    };

    // rgb转hex
    const colorHex = (value: any) => {
      if (!value) {
        return '#ffffff';
      }
      let sColor = [value.r.toString(), value.g.toString(), value.b.toString(), value.a.toString()];
      value = '';
      sColor
        .map((v) => {
          v = parseInt(v.replace(/[^\d]/gi, ''), 10).toString(16);
          value += v.length == 1 ? '0' + v : v;
        })
        .join('');
      return '#' + value;
    };

    const rgbToHex = (str: string) => {
      const reg = /^(rgb|RGB)/;
      const color = str;
      if (reg.test(color)) {
        let strHex = '#';
        // 把RGB的3个数值变成数组
        const colorArr = color.replace(/(?:\(|\)|rgb|RGB)*/g, '').split(',');

        // 转成16进制
        for (let i = 0; i < colorArr.length; i++) {
          let hex = Number(colorArr[i]).toString(16);
          if (hex === '0') {
            hex += hex;
          }
          strHex += hex;
        }
        return strHex;
      } else {
        return String(color);
      }
    };

    const getBlob = (res: any) => {
      let data = res.toDataURL('image/jpeg', 1);

      //this.strawUrl = data;

      data = data.split(',')[1];

      data = window.atob(data);

      var ia = new Uint8Array(data.length);

      for (var i = 0; i < data.length; i++) {
        ia[i] = data.charCodeAt(i);
      }

      return new Blob([ia], {
        type: 'image/jpeg'
      });
    };
    //新增渐变
    const handleTrackClick = (e: any) => {
      if (myGradientColors.value.gradient.length >= 5) {
        return;
      }
      const targetRect: any = e.target.getBoundingClientRect();
      const disX = e.pageX - targetRect.x;
      const dis = parseFloat((disX / targetRect.width).toFixed(4));
      // 找出前后的颜色
      // 取色器
      let content: any = gradientDom.value;
      let width = content.offsetWidth;
      let height = content.offsetHeight;
      let canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const ctx: any = canvas.getContext('2d');
      ctx.fillStyle = '#ffffff';
      let grd = ctx.createLinearGradient(0, 0, width, 0);
      for (let item of myGradientColors.value.gradient) {
        const pos: any = item.position;
        const per = pos.replace('%', '') / 100;
        grd.addColorStop(per, item.color);
      }
      ctx.fillStyle = grd;
      ctx.fillRect(0, 0, width, height);
      const imageData = ctx.getImageData(disX, 8, 1, 1);

      let hex8 = '';
      if (props.hiddenAlpha) {
        hex8 = rgbToHex(`rgb(${imageData.data[0]},${imageData.data[1]},${imageData.data[2]})`);
      } else {
        hex8 = colorHex({
          r: imageData.data[0],
          g: imageData.data[1],
          b: imageData.data[2],
          a: imageData.data[3]
        });
      }

      const cloneGr = cloneDeep(myGradientColors.value);
      cloneGr.gradient.push({
        color: hex8,
        position: dis * 100 + '%'
      });
      cloneGr.gradient.sort((a: any, b: any) => {
        return parseFloat(a.position.replace('%', '')) - parseFloat(b.position.replace('%', ''));
      });
      const index = cloneGr.gradient.findIndex((item: any) => {
        return item.position === dis * 100 + '%';
      });
      currentGradientIndex.value = index;
      updateColor(cloneGr, 'all');
    };

    //渐变item按下事件
    const handleGradientItemMouseMove = (e: any) => {
      const track: any = gradientTrackDom.value;
      const targetRect: any = track?.getBoundingClientRect();
      const disX = e.pageX - targetRect.x;
      let dis = parseFloat((disX / targetRect.width).toFixed(4));
      if (dis < 0) {
        dis = 0;
      }
      if (dis > 1) {
        dis = 1;
      }
      myGradientColors.value.gradient[currentGradientIndex.value].position = dis * 100 + '%';
    };

    const handleGradientItemMouseUp = () => {
      const cloneGr = cloneDeep(myGradientColors.value);

      const dis = myGradientColors.value.gradient[currentGradientIndex.value].position;
      document.removeEventListener('mousemove', handleGradientItemMouseMove);
      document.removeEventListener('mouseup', handleGradientItemMouseUp);

      cloneGr.gradient.sort((a: any, b: any) => {
        return parseFloat(a.position.replace('%', '')) - parseFloat(b.position.replace('%', ''));
      });

      const index = cloneGr.gradient.findIndex((item: any) => {
        return item.position === dis;
      });

      updateColor(cloneGr, 'all');
      setTimeout(() => {
        currentGradientIndex.value = index;
      }, 0);
    };

    const handleGradientItemMouseDown = (e: any, index: any, item: any) => {
      currentGradientIndex.value = index;
      document.addEventListener('mousemove', handleGradientItemMouseMove);
      document.addEventListener('mouseup', handleGradientItemMouseUp);
    };

    // 渐变角度下拉旋转事件
    const handleRotateMouseDown = (e: any) => {
      handleRotateMouseMove(e);
      document.addEventListener('mousemove', handleRotateMouseMove);
      document.addEventListener('mouseup', handleRotateMouseUp);
    };

    // 渐变角度托盘按下后移动
    const handleRotateMouseMove = (e: any) => {
      // 数据收集
      const area: any = rotateAreaDom.value;
      const { x, y, width, height } = area.getBoundingClientRect();
      const { pageX: currentX, pageY: currentY } = e;
      // let startX = x + width;
      // let startY = y + height;
      let startX = x + width / 2;
      let startY = y;
      let center = {
        x: x + width / 2,
        y: y + height / 2
      };
      const before = Math.atan2(startY - center.y, startX - center.x) / (Math.PI / 180);
      const after = Math.atan2(currentY - center.y, currentX - center.x) / (Math.PI / 180);

      let deg = Math.ceil(after - before);
      if (Math.ceil(after - before) < 0) {
        deg = deg + 360;
      }
      if (deg > 360) {
        const num = Math.floor(deg / 360);
        deg = deg - num * 360;
      }

      updateColor(deg, 'direction');
      // this.angle = deg;
      // this.mGradientColor.direction = this.angle + 'deg';
      // this.$emit('updateGradient', this.mGradientColor);
    };
    const handleRotateMouseUp = () => {
      document.removeEventListener('mousemove', handleRotateMouseMove);
      document.removeEventListener('mouseup', handleRotateMouseUp);
    };

    // 鼠标移动事件，重新渲染、取色
    const handleMove = (ctx: any, e: any) => {
      const imageData = ctx.getImageData(e.pageX, e.pageY, 1, 1);
      strawPreviewDom.style.left = e.pageX - 70 + 'px';
      strawPreviewDom.style.top = e.pageY - 70 + 'px';
      // console.log(imageData.data);

      if (props.hiddenAlpha) {
        const hex8 = rgbToHex(`rgb(${imageData.data[0]},${imageData.data[1]},${imageData.data[2]})`);

        strawPreviewDom.querySelector('.inner').style.borderColor = hex8;
        strawPreviewDom.querySelector('.squre').style.backgroundColor = hex8;
        //this.handleColorChange({ hex8: hex8 });
        return hex8;
      } else {
        let color = '';

        if (props.colorMode === 'HEX8') {
          color = colorHex({
            r: imageData.data[0],
            g: imageData.data[1],
            b: imageData.data[2],
            a: imageData.data[3]
          });
        } else if (props.colorMode === 'HEX') {
          color = rgbToHex(`rgb(${imageData.data[0]},${imageData.data[1]},${imageData.data[2]})`);
        } else if (props.colorMode === 'RGBA') {
          color = `rgb(${imageData.data[0]},${imageData.data[1]},${imageData.data[2]},${imageData.data[3]})`;
        } else if (props.colorMode === 'RGB') {
          color = `rgb(${imageData.data[0]},${imageData.data[1]},${imageData.data[2]})`;
        }
        strawPreviewDom.querySelector('.inner').style.borderColor = color;
        strawPreviewDom.querySelector('.squre').style.backgroundColor = color;
        //this.handleColorChange({ hex8: hex8 });
        return color;
      }
    };

    const handleResize = async (ctx: any, canvas: any) => {
      // resize 重新截图，重新画
      let content = document.body; //(document as any).getElementById("app");
      let width = content.offsetWidth;
      let height = content.offsetHeight;
      let scale = 2;

      canvas.width = width * scale;
      canvas.height = height * scale;

      let opts = {
        scale: scale,
        logging: true,
        width: width,
        height: height,
        allowTaint: false,
        useCORS: true
      };
      const res = await html2canvas(content, opts);
      const base64 = res.toDataURL('image/jpeg', 1);
      let img: any = new Image();
      img.src = base64;
      img.onload = () => {
        const captureImgMuti = img.width / window.innerWidth;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, img.width / captureImgMuti, img.height / captureImgMuti);
      };
    };

    const strawColor = async (e: any) => {
      if (strawing) return;
      strawing = true;
      let lastColor = props.color;
      let content = document.body; //(document as any).getElementById("app");
      let width = content.offsetWidth;
      let height = content.offsetHeight;
      let windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      let windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

      // let canvas = document.createElement("canvas");
      let scale = 2;

      // canvas.width = width * scale;
      // canvas.height = height * scale;

      let opts = {
        scale: scale,
        logging: true,
        width: width,
        height: height,
        allowTaint: false,
        useCORS: true
      };

      try {
        const res = await html2canvas(content, opts);
        const base64 = res.toDataURL('image/jpeg', 1);
        // const base64 =  res.toDataURL("image/png")

        let canvas = document.createElement('canvas');
        canvas.id = 'colorPickerCanvas';
        canvas.width = windowWidth;
        canvas.height = windowHeight;
        canvas.style.position = 'fixed';
        canvas.style.zIndex = '9998';
        canvas.style.top = '0px';
        canvas.style.left = '0px';
        canvas.style.width = `${windowWidth}px`;
        canvas.style.height = `${windowHeight}px`;
        canvas.style.cursor = 'crosshair';
        canvas.style.opacity = '0';
        let ctx: any = canvas.getContext('2d');
        // 加个白色背景，防止一些没有颜色的、透明的，在吸色时出现问题(色值不对， 0 0 0 0)
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        const img: any = new Image();
        img.src = base64;
        img.onload = () => {
          const captureImgMuti = img.width / windowWidth;
          ctx.drawImage(
            img,
            0,
            0,
            img.width,
            img.height,
            0,
            0,
            img.width / captureImgMuti,
            img.height / captureImgMuti
          );
          document.body.appendChild(canvas);
          const showDom = document.createElement('div');
          showDom.id = 'straw-preview-div';
          showDom.innerHTML = '<div class="inner"></div><div class="squre"></div><div class="bd"></div>';
          strawPreviewDom = showDom;
          //document.documentElement.appendChild(strawPreviewDom);
          document.body.appendChild(strawPreviewDom);
          handleMove(ctx, e);
          const wrapperMoveFunc = (e: any) => {
            handleMove(ctx, e);
          };
          // 窗口大小改变时，重新截图 mousedown
          const wrapperResizeFunc = debounce((e: any) => {
            handleResize(ctx, canvas);
          }, 150);
          document.addEventListener('mousemove', wrapperMoveFunc);
          window.addEventListener('resize', wrapperResizeFunc);

          strawPreviewDom.addEventListener('mousedown', (e: any) => {
            document.body.removeChild(strawPreviewDom);
            //document.documentElement.removeChild(strawPreviewDom);
            document.removeEventListener('mousemove', wrapperMoveFunc);
            window.removeEventListener('resize', wrapperResizeFunc);
            document.body.removeChild((document as any).getElementById('colorPickerCanvas'));
            strawing = false;
            if (e.button === 0) {
              updateColor(handleMove(ctx, e));
            }
            window.event ? (window.event.cancelBubble = true) : e.stopPropagation();
            e.preventDefault();
          });

          strawPreviewDom.addEventListener('pointerdown', (e: any) => {
            document.body.removeChild(strawPreviewDom);
            //document.documentElement.removeChild(strawPreviewDom);
            document.removeEventListener('mousemove', wrapperMoveFunc);
            window.removeEventListener('resize', wrapperResizeFunc);
            document.body.removeChild((document as any).getElementById('colorPickerCanvas'));
            strawing = false;
            if (e.button === 0) {
              updateColor(handleMove(ctx, e));
            }
            window.event ? (window.event.cancelBubble = true) : e.stopPropagation();
            e.preventDefault();
          });

          strawPreviewDom.oncontextmenu = (e: any) => {
            document.body.removeChild(strawPreviewDom);
            document.removeEventListener('mousemove', wrapperMoveFunc);
            window.removeEventListener('resize', wrapperResizeFunc);
            document.body.removeChild((document as any).getElementById('colorPickerCanvas'));
            //updateColor(lastColor);
            // 取消时回复原来的颜色
            //this.handleColorChange({ hex8: lastColor });
            strawing = false;
            e.preventDefault();
            e.stopPropagation();
          };
        };
      } catch (error) {
        console.log('error', error);
      }
    };

    //上传图片
    const uploadImage = async (e: any) => {
      uploadText.value = '上传中……';
      isUpload.value = true;
      const files = e.target.files;
      if (!files.length) {
        uploadText.value = '上传图片';
        //emit('uploaded', { isSuccess: false, value: '文件不能为空' });
        ElMessage.error('文件不能为空');
        isUpload.value = false;
        return;
      }

      const file = files[0];
      fileName.value = file?.name ?? '';
      console.log('file',file);
      let sizeLimit = props.uploadInfo.limitSize;
      const isLt1M = file.size / 1024 / 1024 < sizeLimit;
      if (!isLt1M) {
        // emit('uploaded', {
        //   isSuccess: false,
        //   value: '文件大小不能超过' + sizeLimit + 'M'
        // });
        ElMessage.error('文件大小不能超过' + sizeLimit + 'M');
        isUpload.value = false;
        return false;
      }
      const formData = new FormData();
      formData.append('fileName', files[0]);
      progressText.value = 20;

      await new Promise((resolve:any) => {
        setTimeout(() => {
           progressText.value = 60;
           resolve();
        }, 500);
      })

      try {
        const res: any = await fetch(props.uploadInfo.url, {
          method: 'post',
          body: formData
        });
        if (res.status === 200) {
          const res2 = await res.json();
          console.log('res2', res2);
          emit('updateImgUrl', res2?.data?.filename);
          progressText.value = 100;
        } else {
          ElMessage.error('上传失败');
          // emit('uploaded', { isSuccess: false, value: '上传失败' });
        }
      } catch (error) {
        ElMessage.error('上传失败');
        // emit('uploaded', { isSuccess: false, value: error });
      }
      isUpload.value = false;
      uploadText.value = '上传图片';
    };

    const tabClick = (item: any) => {
      activeTab.value = item.tab;

      emit('update:selectType', item.tab);
      if (activeTab.value === ColorType.Color) {

        nextTick(() => {
           updateColor(myColors.value);
        })
       
      } else if (activeTab.value === ColorType.GradientColor) {
        nextTick(() => { 
          updateColor(cloneDeep(myGradientColors.value), 'all');
        })
        
      }
    };

    const deletOneGradientItem = (e: any) => {
      if (myGradientColors.value.gradient.length > 2) {
        myGradientColors.value.gradient.splice(currentGradientIndex.value, 1);
        currentGradientIndex.value = 0;
        updateColor(cloneDeep(myGradientColors.value), 'all');
      }
    };

    const recentGradientClick = (item: any) => {
      myGradientColors.value = gradientPointColors(item.gradient);
      updateColor(cloneDeep(myGradientColors.value), 'all');
    };

    const handleWindowKey = (e: any) => {
      if (e.keyCode === 46 && myGradientColors.value.gradient.length > 2) {
        myGradientColors.value.gradient.splice(currentGradientIndex.value, 1);
        currentGradientIndex.value = 0;
        updateColor(cloneDeep(myGradientColors.value), 'all');

        e.stopPropagation();
        e.preventDefault();
      }
    };

    const popoverShow = () => {
      window.addEventListener('keydown', handleWindowKey);
      const v = sessionStorage.getItem('recentColorList');
      const g = sessionStorage.getItem('recentGradientList');
      if (v) {
        try {
          recentColorList.value = JSON.parse(v);
        } catch (error) {
          console.log(error);
        }
      }
      if (g) {
        try {
          recentGradientList.value = JSON.parse(g);
        } catch (error) {
          console.log(error);
        }
      }
    };
    const popoverHide = () => {
      console.log('popoverHide');
      window.removeEventListener('keydown', handleWindowKey);

      if (activeTab.value === ColorType.Color) {
        recentColorList.value.unshift(myColors.value);
        // 判断当前颜色列表是否有相同值，如果有，去重
        recentColorList.value = uniq(recentColorList.value);
        if (recentColorList.value.length >= 12) {
          recentColorList.value = recentColorList.value.slice(0, 12);
        }
        console.log('recentColorList.value',recentColorList.value);
        sessionStorage.setItem('recentColorList', JSON.stringify(recentColorList.value));
      } else if (activeTab.value === ColorType.GradientColor) {
        // 判断当前颜色列表是否有相同值，如果有，不更新数组
        if (
          !some(recentGradientList.value, {
            gradient: gradientString(myGradientColors.value as any)
              .replace('linear-gradient(', '')
              .replace(')', '')
          })
        ) {
          recentGradientList.value.unshift({
            gradient: gradientString(myGradientColors.value as any)
              .replace('linear-gradient(', '')
              .replace(')', '')
          });
        }

        if (recentGradientList.value.length >= 12) {
          recentGradientList.value = recentGradientList.value.slice(0, 12);
        }
        sessionStorage.setItem('recentGradientList', JSON.stringify(recentGradientList.value));
      }
    };


    // async function brandColorFun(){ 
    //   const res:any = await fetch('/webapi/user/brand/color');
    //   if (res.status === 200) {
    //       const res2 = await res.json();

    //   } 
    // }

    // brandColorFun();

    onMounted(() => {
      //  window.addEventListener('keydown', handleWindowKey);
    });

    onBeforeUnmount(() => { 
      console.log('onBeforeUnmount-onBeforeUnmount')
      if(props.sketchShow){
        popoverHide();
      }
      
    })

    watch(
      () => props.sketchShow,
      (newV) => {
        newV ? popoverShow() : popoverHide();
      }
    );

    watch(
      () => props.selectType,
      (newV) => {
        activeTab.value = newV;
      }
    );
    watch(
      () => props.color,
      (newV) => {
        if (!newV) return;
        let activeTabClone: any = undefined;

        console.log('typeof newV', typeof newV);

        if (typeof newV === 'string') {
          activeTabClone = ColorType.Color;
        } else if (typeof newV === 'object') {
          activeTabClone = ColorType.GradientColor;
        }

        if (activeTabClone !== undefined && activeTabClone !== activeTab.value) {
          activeTab.value = activeTabClone;
          emit('update:selectType', activeTabClone);
        }

        if (activeTab.value === ColorType.Color) {
          myColors.value = cloneDeep(newV);
        } else if (activeTab.value === ColorType.GradientColor) {
          myGradientColors.value = cloneDeep(newV);
        }
      }
    );
    watch(()=>props.pictureUrl,(newV) => {
      imageUrl.value = newV;
    })

    const colorModeList = computed(() => {
      return props.typeList.map((item: any) => {
        return {
          text: colorMap[item as ColorType],
          tab: item
        };
      });
    });

    const gradientColorStr = computed(() => {
      return gradientString(myGradientColors.value as GradientColor);
    });
    const currentGradientColor = computed(() => {
      return myGradientColors.value.gradient[currentGradientIndex.value].color;
    });

    const angle = computed(() => {
      return Number(myGradientColors.value.direction.replace('deg', ''));
    });

    return {
      myColors,
      myGradientColors,
      colorModeList,
      activeTab,
      strawColor,
      updateColor,
      currentGradientIndex,
      gradientColorStr,
      showAngleBox,
      angle,
      currentGradientColor,
      gradientDom,
      handleTrackClick,
      gradientTrackDom,
      handleGradientItemMouseDown,
      rotateAreaDom,
      handleRotateMouseDown,
      ColorType,
      uploadText,
      uploadImage,
      tabClick,
      deletOneGradientItem,
      recentGradientClick,
      recentColorList,
      recentGradientList,
      imageUrl,
      isUpload,
      progressText,
      fileName
    };
  }
});
